import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 md:flex-row md:items-start" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "relative h-28 w-28" }
const _hoisted_4 = {
  viewBox: "0 0 100 100",
  class: "h-28 w-28 -rotate-90"
}
const _hoisted_5 = ["stroke-dasharray"]
const _hoisted_6 = { class: "absolute inset-0 flex flex-col items-center justify-center" }
const _hoisted_7 = { class: "text-foreground text-2xl font-semibold leading-none" }
const _hoisted_8 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_9 = { class: "font-medium text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("svg", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("circle", {
            class: "stroke-gray-200",
            cx: "50",
            cy: "50",
            r: "42",
            fill: "none",
            stroke: "var(--border)",
            "stroke-width": "8"
          }, null, -1 /* CACHED */)),
          ($setup.healthScore !== null)
            ? (_openBlock(), _createElementBlock("circle", {
                key: 0,
                cx: "50",
                cy: "50",
                r: "42",
                fill: "none",
                class: _normalizeClass($setup.scoreColor($setup.healthScore)),
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-width": "8",
                "stroke-dasharray": `${$setup.dash} ${$setup.circumference}`
              }, null, 10 /* CLASS, PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true)
        ])),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString($setup.healthScore ?? '-'), 1 /* TEXT */),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-muted-foreground mt-1 text-[10px] uppercase tracking-wider" }, " health ", -1 /* CACHED */))
        ])
      ]),
      _createElementVNode("div", null, [
        ($setup.healthScore !== null)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["text-lg font-semibold", $setup.scoreColor($setup.healthScore)])
            }, _toDisplayString(_ctx.$t(
                            'contact.timeline.stats.healthScore.' +
                                $setup.getContactHealthScoreStatus($setup.healthScore),
                        )), 3 /* TEXT, CLASS */))
          : _createCommentVNode("v-if", true),
        ($setup.trendScore)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('contact.timeline.stats.healthScore.trend')) + ": ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(
                                'contact.timeline.stats.healthScore.' +
                                    $setup.getContactHealthScoreTrend($setup.trendScore),
                            )), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}